import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FloatingButton } from './style';

const WhatsAppFloat = () => {
  const phoneNumber = '1234567890'; // Replace with your WhatsApp number
  const message = 'Hello! I would like to chat with you.'; // Optional default message

  return (
    <FloatingButton
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </FloatingButton>
  );
};

export default WhatsAppFloat;